<div class="w-full mx-auto space-y-4 pt-10">

    <!-- Bouton vert -->
    <button
        class="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-sm transition"
        (click)="navigateToCheckin()">
        Entrer
    </button>

    <!-- Bouton rouge -->
    <button
        class="w-full bg-red-500 hover:bg-red-600 text-white font-semibold py-3 rounded-sm transition"
        (click)="navigateToCheckout()">
        Sortir
    </button>

</div>